import API from '../API'

export default (previousState, action) => {
    if (!previousState) previousState = {};

    previousState.status = API.instance.status;

    return { ...previousState }
}